import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { TicketDetailDto } from "src/store/ticket/type";
import { TicketStatusContainer } from "./componentes/ticketStatus";

const TicketRightSideBar = ({
  selectedTicket,
  setSelectedTicket,
}: {
  selectedTicket: TicketDetailDto;
  setSelectedTicket: (selectedTicket: TicketDetailDto) => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showDelete, setShowDelete] = useState(false);
  return (
    <React.Fragment>
      {/* {showDelete && (
        <CancelAlert
          message={"Talebi kapatmak istediğine emin misiniz?"}
          onConfirm={() => {
            setShowDelete(false);
            dispatch(
              updatetoSolvedTicket({
                payload: {
                  onSuccess: (message, payload) => {
                    dispatch(
                      getTicketDetails({
                        payload: {
                          onSuccess: (message, payload) =>
                            setSelectedTicket(payload),
                          onError: () => {},
                        },
                        id: selectedTicket.Id,
                      })
                    );
                  },
                  onError: message => {},
                },
                id: selectedTicket?.Id,
              })
            );
          }}
          onCancel={() => {
            setShowDelete(false);
          }}
        />
      )} */}
      <div className="ticketRightSideBar">
        <div>
          <div className="mb-2">
            {TicketStatusContainer(
              selectedTicket.TicketStatusTypeId,
              selectedTicket.TicketStatusType
            )}
          </div>
          <h3 className="mb-2">{selectedTicket.ClientClientName}</h3>{" "}
          <div className="mb-1">{selectedTicket.ClientCorporateEmail}</div>
          <div className="mb-1">{selectedTicket.ClientCorporatePhone}</div>
          <button className="btn-sm btn btn-secondary mb-2">
            <a
              href={"/client/details/1/" + selectedTicket.ClientId}
              target="_blank"
              className="text-light"
              rel="noreferrer"
            >
              Müşteriye Git
            </a>
          </button>
          <div className="mb-2">Talep Kodu : #{selectedTicket.Code}</div>
          <div className="mb-2">Talep Tipi : {selectedTicket.TicketType}</div>
          <div className="mb-2">Talep Konusu : {selectedTicket.Subject}</div>
          <div className="text-muted mb-2" style={{ fontSize: 12 }}>
            Oluşturulma Zamanı :{" "}
            {moment(selectedTicket.CreateTime).format("DD/MM/yyyy HH:mm")}
          </div>
        </div>
        <div>
          {!(
            selectedTicket.TicketStatusTypeId === 3 ||
            selectedTicket.TicketStatusTypeId === 4
          ) && (
            <button
              type="button"
              color="success"
              onClick={() => {
                return setShowDelete(true);
              }}
              className=" btn btn-danger "
            >
              {t("Tickets.CloseTicketButton")}
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketRightSideBar;
